import * as React from 'react';

import { checkExperiment, ribbonExperiments } from '@1js/acui-experiments';

import { AppTooltipHost } from '../AppTooltipHost';
import { AppTooltipHostWrapperProps } from './AppTooltipHostWrapper.Props';

/**
 * A higher order component that will add an AppTooltipHost to its children
 */
export class AppTooltipHostWrapper extends React.Component<AppTooltipHostWrapperProps> {
  private _appTooltipHost: AppTooltipHost | undefined;
  private _contentRef: React.RefObject<HTMLDivElement>;

  public constructor(props: AppTooltipHostWrapperProps) {
    super(props);

    this._contentRef = React.createRef<HTMLDivElement>();
  }

  public componentDidMount() {
    const {
      tooltipId,
      tooltipLabel,
      hoverElement,
      tooltipTargetRef,
      updateTooltipsHidden,
      setTooltipElement,
      tooltipDirection,
      tooltipDirectionForRTL,
      isMenuComponent,
    } = this.props;

    if (!updateTooltipsHidden || !setTooltipElement) {
      return;
    }

    this._appTooltipHost = new AppTooltipHost({
      updateTooltipsHidden,
      setTooltipElement,
      refElement: this._contentRef,
      controlId: tooltipId,
      controlLabel: tooltipLabel ?? '',
      hoverElement,
      performSetOnNextFrame: !!checkExperiment(this.context, ribbonExperiments.delayRenderTooltipsIsEnabled),
      anchorElement: tooltipTargetRef,
      tooltipDirection,
      tooltipDirectionForRTL,
      isMenuComponent,
    });

    this._appTooltipHost.registerTooltipHostActions();
  }

  public componentDidUpdate() {
    const { tooltipLabel, tooltipTargetRef } = this.props;
    if (this._appTooltipHost) {
      tooltipLabel && this._appTooltipHost.updateTooltip(tooltipLabel);
      tooltipTargetRef && this._appTooltipHost.updateTooltipAnchor(tooltipTargetRef);
    }
  }

  public componentWillUnmount() {
    this._appTooltipHost?.unregisterTooltipHostActions();
  }

  public shouldComponentUpdate(nextProps: AppTooltipHostWrapperProps): boolean {
    return this.props.children !== nextProps.children || this.props.containerClassname !== nextProps.containerClassname;
  }

  public render() {
    const { children, containerClassname } = this.props;

    return (
      <div ref={this._contentRef} className={containerClassname}>
        {children}
      </div>
    );
  }
}
